import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import api from '../utils/api'

const Profile = () => {
  const { user } = useAuth()
  const [name, setName] = useState('')
  const [birthDate, setBirthDate] = useState('')
  const [organization, setOrganization] = useState('')
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (user) {
      setName(user.name || '')
      setBirthDate(user.birth_date || '')
      setOrganization(user.organization || '')
    }
  }, [user])

  const handleUpdateProfile = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMessage('')
    setLoading(true)

    try {
      await api.put('/users/profile', {
        name,
        birth_date: birthDate,
        organization
      })
      setMessage('프로필이 성공적으로 업데이트되었습니다.')
      
      // 로컬 스토리지의 user 정보도 업데이트
      const updatedUser = { ...user, name, birth_date: birthDate, organization }
      localStorage.setItem('user', JSON.stringify(updatedUser))
      
      // 페이지 새로고침하여 헤더 등에 반영
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    } catch (err: any) {
      setError(err.response?.data?.error || '프로필 업데이트에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMessage('')

    if (newPassword !== confirmPassword) {
      setError('새 비밀번호가 일치하지 않습니다.')
      return
    }

    if (newPassword.length < 6) {
      setError('비밀번호는 최소 6자 이상이어야 합니다.')
      return
    }

    setLoading(true)

    try {
      await api.post('/auth/change-password', {
        email: user?.email,
        currentPassword,
        newPassword
      })
      setMessage('비밀번호가 성공적으로 변경되었습니다.')
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
    } catch (err: any) {
      setError(err.response?.data?.error || '비밀번호 변경에 실패했습니다.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="container">
      <h1 style={{ marginBottom: '20px' }}>프로필 관리</h1>

      {message && (
        <div className="alert alert-success" style={{ marginBottom: '20px' }}>
          {message}
        </div>
      )}

      {error && (
        <div className="alert alert-error" style={{ marginBottom: '20px' }}>
          {error}
        </div>
      )}

      <div style={{ display: 'grid', gap: '20px', maxWidth: '800px' }}>
        {/* 기본 정보 */}
        <div className="card">
          <h2 style={{ marginBottom: '20px' }}>기본 정보</h2>
          <form onSubmit={handleUpdateProfile}>
            <div className="form-group">
              <label>이메일</label>
              <input
                type="email"
                value={user?.email || ''}
                disabled
                style={{ background: '#f5f5f5' }}
              />
              <small style={{ color: '#666' }}>이메일은 변경할 수 없습니다.</small>
            </div>

            <div className="form-group">
              <label>이름</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>생년월일</label>
              <input
                type="date"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                required
              />
              <small style={{ color: '#666' }}>이수증명서 발급을 위해 필수입니다.</small>
            </div>

            <div className="form-group">
              <label>소속기관</label>
              <input
                type="text"
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
                placeholder="예: ○○교회"
                required
              />
              <small style={{ color: '#666' }}>이수증명서 발급을 위해 필수입니다.</small>
            </div>

            <button 
              type="submit" 
              className="btn btn-primary" 
              disabled={loading}
              style={{ width: '100%' }}
            >
              {loading ? '저장 중...' : '프로필 업데이트'}
            </button>
          </form>
        </div>

        {/* 비밀번호 변경 */}
        <div className="card">
          <h2 style={{ marginBottom: '20px' }}>비밀번호 변경</h2>
          <form onSubmit={handleChangePassword}>
            <div className="form-group">
              <label>현재 비밀번호</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>새 비밀번호</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>

            <div className="form-group">
              <label>새 비밀번호 확인</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-secondary" 
              disabled={loading}
              style={{ width: '100%' }}
            >
              {loading ? '변경 중...' : '비밀번호 변경'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Profile




